import { Component } from '@theme/component';

/**
 * Zoekveld boven een lange filterlijst ("Zoek een merk"), uit het
 * catalogus-redesign. Verbergt alleen de waarden die niet passen; het filter
 * zelf blijft Horizon's `facet-inputs-component`.
 *
 * Het veld heeft geen `name` (gaat dus niet mee in het formulier) en staat
 * buiten `facet-inputs-component`, zodat het `change`-event bij het verlaten
 * van het veld geen filterupdate start. Enter zou het formulier versturen en
 * de pagina herladen; dat vangen we af.
 *
 * Tijdens het zoeken zet het component `data-searching`: de CSS toont dan ook
 * de waarden die "Toon alle" nog verborg, en verbergt die knop zelf.
 *
 * @typedef {Object} FacetSearchRefs
 * @property {HTMLInputElement} input - Het zoekveld
 * @property {HTMLElement} [empty] - "Geen merk gevonden."
 *
 * @extends {Component<FacetSearchRefs>}
 */
class FacetSearchComponent extends Component {
  requiredRefs = ['input'];

  updatedCallback() {
    super.updatedCallback();
    // Na een re-render (filter gekozen) kan de lijst vernieuwd zijn; de
    // zoekterm in het veld blijft staan, dus pas hem opnieuw toe.
    this.search();
  }

  search() {
    const query = this.refs.input.value.trim().toLocaleLowerCase();
    let matches = 0;

    for (const item of this.querySelectorAll('.facets__inputs-list-item')) {
      const label = item.querySelector('[data-label]')?.getAttribute('data-label') ?? item.textContent ?? '';
      const isMiss = query !== '' && !label.toLocaleLowerCase().includes(query);

      item.toggleAttribute('data-search-miss', isMiss);
      if (!isMiss) matches++;
    }

    this.toggleAttribute('data-searching', query !== '');
    if (this.refs.empty) this.refs.empty.hidden = matches > 0;
  }

  /**
   * @param {KeyboardEvent} event
   */
  preventSubmit(event) {
    if (event.key === 'Enter') event.preventDefault();
  }
}

if (!customElements.get('facet-search-component')) {
  customElements.define('facet-search-component', FacetSearchComponent);
}
